import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { header, headerActive, headerTitle, fullHeight, childrenStyles } from './HistoryEntryHeader.less';

const HistoryEntryHeader = ({ title, children, active = false }) => (
  <div className={`${header} ${window.__ROLE !== 'DOCTOR' && active ? headerActive : ''}`}>
    <Grid fluid className={fullHeight}>
      <Row middle="xs" className={fullHeight}>
        <Col xs={7} sm={5}>
          <h6 className={headerTitle}>{title}</h6>
        </Col>
        <Col xs={5} sm={7} className={childrenStyles}>
          {children}
        </Col>
      </Row>
    </Grid>
  </div>
);

HistoryEntryHeader.propTypes = {
  title: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node,
};

export default HistoryEntryHeader;
